
<div class="pg-share">
  <div class="bg"></div>
  <div class="logo"></div>
  <div class="scroll-wrapper">
    <div class="scroll">
      <div>{{nickname}}</div>
    </div>
  </div>
  <div class="friend">
    <div class="prize-wrapper">
      <Prize
        v-for="(prize, index) in myPrize"
        :key="index"
        :prize="prize.icon"
        :name="prize.title"
      >
      </Prize>
    </div>
  </div>
  <!-- <div class="human"></div> -->
  <div v-if="showHelp" class="help" @click="help"></div>
  <div v-else class="draw" @click="goHome"></div>
  <a v-if="!ingame" class="btn-download ios" ref="ios" @click="iosHandler"></a>
  <a class="btn-download android" ref="android" @click="downloadHandler"></a>
</div>
